import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { MENU_ITEMS } from '../../../config/constants';
import './Sidebar.css';

const Sidebar = () => {
    const { logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
    };

    const handleMenuClick = (e, item) => {
        if (!item.implemented) {
            e.preventDefault();
            alert(`"${item.label}" wird demnächst implementiert.`);
        }
    };

    return (
        <aside className="sidebar">
            <nav className="sidebar-nav">
                <div className="nav-section">
                    {MENU_ITEMS.map((item, index) => (
                        <NavLink
                            key={item.id}
                            to={item.route}
                            onClick={(e) => handleMenuClick(e, item)}
                            className={({ isActive }) =>
                                `nav-item ${isActive ? 'active' : ''} ${index < 3 ? 'golden' : ''} ${!item.implemented ? 'not-implemented' : ''}`
                            }
                        >
                            {item.icon && <span className={`icon icon-${item.icon}`}></span>}
                            {item.label}
                            {!item.implemented && <span className="badge-soon">Bald</span>}
                        </NavLink>
                    ))}
                </div>

                <div className="nav-section-divider">• • •</div>

                <div className="nav-section">
                    <NavLink
                        to="/"
                        onClick={(e) => {
                            e.preventDefault();
                            alert('"Dashboard" wird demnächst implementiert.');
                        }}
                        className={({ isActive }) =>
                            `nav-item ${isActive ? 'active' : ''} not-implemented`
                        }
                    >
                        <span className="icon icon-dashboard"></span>
                        Dashboard
                        <span className="badge-soon">Bald</span>
                    </NavLink>
                    <NavLink
                        to="/"
                        onClick={(e) => {
                            e.preventDefault();
                            alert('"Profil" wird demnächst implementiert.');
                        }}
                        className={({ isActive }) =>
                            `nav-item ${isActive ? 'active' : ''} not-implemented`
                        }
                    >
                        <span className="icon icon-user"></span>
                        Profil
                        <span className="badge-soon">Bald</span>
                    </NavLink>
                    <NavLink
                        to="/"
                        onClick={(e) => {
                            e.preventDefault();
                            alert('"News / Newsletter" wird demnächst implementiert.');
                        }}
                        className="nav-item not-implemented"
                    >
                        News / Newsletter
                        <span className="badge-soon">Bald</span>
                    </NavLink>
                </div>

                <div className="sidebar-footer">
                    <NavLink to="/" className="footer-link">
                        Impressum
                    </NavLink>
                    <NavLink to="/" className="footer-link">
                        Datenschutz
                    </NavLink>
                    <button onClick={handleLogout} className="logout-button">
                        Abmelden
                    </button>
                </div>
            </nav>
        </aside>
    );
};

export default Sidebar;